import Notification from './Notification';

export default props=>{
	const jsx = (<div className="child">
		<style jsx>{`

.child{
    position: absolute;
    height: 0;
    /* clear: both; */
	right: 166px;
    bottom: 25px;
}

.arrow_box {
position: relative;
	top: 12px;
	
	box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
    border: solid 1px #dee2e6;
    background-color: #ffffff;

	font-family: NotoSansCJKkr;
    font-size: 14px;
    color: #343a40;
	border-radius: 5px;
	
	width: 312px;
	height: 400px;
	z-index:2;
    /* overflow-y: scroll; */
    /* overflow-x: hidden; */
	/* right: 146px; */
}

.arrow_box:after, .arrow_box:before {
	bottom: 100%;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

.arrow_box:before {
	border-color: rgba(222, 226, 230, 0);
	border-bottom-color: #dee2e6;
	border-width: 7px;
	margin-left: -7px;
}


.arrow_box:after {
	border-color: rgba(255, 255, 255, 0);
	border-bottom-color: #ffffff;
	border-width: 6px;
	margin-left: -6px;
}

span{
	float: left;
}


.item{
	padding: 8px 30px;
	text-align:center;
}


.tabs{
	color: #343a40;
}
.tab{
	width:25%;
	height: 45px;
	font-size: 12px;
	text-align: center;
	color: #adb5bd;

    padding-top: 15px;
	
}
.tab.on{
	color: #343a40;
	border-bottom: solid 1px black;
}


`}</style>

		<div className="arrow_box hiddenable" style={{ display: props.dNotification }}>
			<Notification />
		</div>


	</div>);
	return(jsx);
}
